import React, { FC } from "react";
import { Box, Stack, Typography, Button, Paper } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

interface EmptyStateProps {
  onCreateSurvey: () => void;
}

export const DMSurveyEmptyState: FC<EmptyStateProps> = ({ onCreateSurvey }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "60vh",
      }}
    >
      <Paper
        sx={{
          p: 6,
          maxWidth: 600,
          textAlign: "center",
          border: (theme) => `2px dashed ${theme.palette.divider}`,
        }}
      >
        <Stack spacing={3} alignItems="center">
          <Typography variant="h5" fontWeight="medium">
            {t("doubleMateriality.defineYear", "Define Year")}
          </Typography>

          <Typography variant="body1" color="text.secondary">
            {t(
              "doubleMateriality.defineYearDescription",
              "To get started with double materiality, please define the reporting year first."
            )}
          </Typography>

          <Button
            variant="contained"
            size="large"
            startIcon={<AddIcon />}
            onClick={onCreateSurvey}
            sx={{ mt: 2 }}
          >
            {t("doubleMateriality.createSurvey", "Create Survey")}
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};
